import React from 'react';
import { Link } from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';
import './cookieConsent.scss';
import routes from '../../utils/commonVariables/routes';
import useTranslate from '../../customHooks/useTranslate';

export default function Cookie() {
    const translate = useTranslate();

    return (
        <CookieConsent
            disableStyles
            cookieName='cookieconsent'
            buttonText={translate('agree')}
            containerClasses='containerCookie'
            buttonClasses='btn-cookie'
        >
            {translate('these_cookies_allow_us_to_remember')}
            <Link
                className='item__cookie-link'
                style={{ fontSize: '15px' }}
                to={routes.cookieConsent}
            >
                {translate('learn_more')}
            </Link>
        </CookieConsent>
    );
}
